var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"layout"},[_vm._m(0),_c('router-view'),_c('footer',{staticClass:"footer"},[_c('PersonalAccess')],1)],1)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"layout__icon_container"},[_c('img',{attrs:{"src":require("@/assets/FourLapsLogo.svg")}})])
}]

export { render, staticRenderFns }